export default "__VITE_ASSET__DjeHs1tn__"